import React from "react";
import { useLocation } from "react-router-dom";

const PayzeIframe = () => {
     const location = useLocation();
     const { url } = location.state || {};
  return (
    <div className="w-full h-[700px] border rounded-lg overflow-hidden">
      <iframe
        src={url}
        width="100%"
        height="100%"
        // frameBorder="0"
        allow="payment"
        title="Payze Checkout"
      />
    </div>
  );
};

export default PayzeIframe;
